import { isDevMode, Component } from '@angular/core';

import { PhoneService } from '../../../services/phone/phone.service';
import { UserEntity } from '@wephone-core/model/entity/user';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { UserRepository } from '@wephone-core/model/repository/user';
import { TranslationService, _ti } from '@wephone-translation';
import { DialogComponentBase } from '@wephone-core-ui';
import { DialogActionButton, Colors } from '@wephone-utils';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'agent-panel-settings',
  templateUrl: 'agent-panel-settings.html'
})
export class AgentPanelSettingComponent extends DialogComponentBase {
//   dialogLeftActions: Array<DialogActionButton> = [];
  dialogRightActions: Array<DialogActionButton> = [];

  audioInputName: string;
  audioOutputName: string;
  sipstackEnabled: boolean;
  devices: Array<any> = [];

  audioInputOptions: Array<any> = [];
  audioOutputOptions: Array<any> = [];

  showSelect = false; // used to fix translate bug in ion-option
  appLanguage: string;
  languages: Array<string>;

  // For account-basic-settings
  currentUser: UserEntity;
  devMode: boolean = isDevMode();

  appAutoLaunch: any;
  autoLaunchEnable: boolean;
  autoLaunchAvailable: boolean;

  constructor(
    dialogRef: MatDialogRef<AgentPanelSettingComponent>,
    public phoneService: PhoneService,
    public translation: TranslationService,
    authService: AuthenticationService
  ) {
    super(dialogRef);

    this.currentUser = UserRepository.getInstance().getObjectById(authService.getUserId());
    this.languages = this.translation.availableLangs.map((x) => x.label);
  }

  // async ionViewWillEnter() {
  //     this.appLanguage = this.translation.getCurrLanguage();

  //     let phone_config = await this.phoneService.loadPhoneConfig();
  //     this.audioInputName = phone_config['input_device'];
  //     this.audioOutputName = phone_config['output_device'];
  //     this.sipstackEnabled = phone_config['sipstack_enabled'];

  //     this.audioInputOptions = [];
  //     this.audioOutputOptions = [];
  //     this.devices = this.phoneService.getAudioDevices();

  //     for (let device of this.devices) {
  //         if (device['is_input'] === 0) {
  //             this.audioOutputOptions.push(device);
  //         }
  //         else {
  //             this.audioInputOptions.push(device);
  //         }
  //     }

  //     this.showSelect = true;
  // }

  sipStackAvailable() {
    return this.phoneService.isSipStackAvailable();
  }

  changeAudioInput(inputDevice: string) {
    this.phoneService.applyPhoneConfig({ input_device: this.audioInputName });
  }

  changeAudioOutput(inputDevice: string) {
    this.phoneService.applyPhoneConfig({ output_device: this.audioOutputName });
  }

  changeLanguage(language: string) {
    this.translation.setAppLanguage(language);
  }

  setSipstackMode() {
    this.phoneService.applyPhoneConfig({ sipstack_enabled: this.sipstackEnabled });
    if (this.sipstackEnabled) {
      this.phoneService.configureAccounts();
    } else {
      this.phoneService.disable();
    }
  }

  changeAutoLaunchState() {
    if (this.autoLaunchAvailable) {
      if (this.autoLaunchEnable) {
        this.appAutoLaunch.enable().then(() => {
          this.successToast(_ti('public.message.update_success'));
        });
      } else {
        this.appAutoLaunch.disable().then(() => {
          this.successToast(_ti('public.message.update_success'));
        });
      }
    }
  }

  // public dismiss(data?) {
  //     this.dismiss(data);
  // }
}
